// extracted by mini-css-extract-plugin
module.exports = {"message":"SuccessModal_message__3BZMv","messsage":"SuccessModal_messsage__28UDA"};